import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取小区标签列表
export const getTag = params => {
    return get("/admin/xiaoqu/pricetag", params);
};
// 新增小区标签
export const addTag = params => {
    return post("/admin/xiaoqu/pricetag", params);
};
// 修改小区标签
export const editTag = params => {
    return put(`/admin/xiaoqu/pricetag/${params.id}`, params);
};
// 删除小区标签
export const deleteTag = params => {
    return del(`/admin/xiaoqu/pricetag/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/tag.js